import {adbApi} from "./adbService";

export const settingsPageApi = adbApi.injectEndpoints({
    endpoints: (builder) => ({
        getSettingsPage: builder.query({
            query: () => ({
                url: `pages/account/settings`,
                method: "GET",
            }),
            invalidatesTags: ["SettingsPage"],
        }),
        getAccountSettings: builder.query({
            query: () => ({
                url: `account/settings`,
                method: "GET",
            }),
            invalidatesTags: ["AccountSettings"],
        }),
        allowToMFA: builder.mutation({
            query: (type) => ({
                url: `account/settings/toggle-mfa/${type}`,
                method: "POST",
            }),
            keepUnusedDataFor: 0.0001,
        }),
        getAuthenticatorQr: builder.query({
            query: () => ({
                url: `account/settings/authenticator/edit`,
                method: "GET",
            }),
            invalidatesTags: ["AuthQrCode"],
        }),
        confirmAuthQrCode: builder.mutation({
            query: (body) => ({
                url: `account/settings/authenticator/confirm`,
                method: "POST",
                body: body,
            }),
            keepUnusedDataFor: 0.0001,
        }),
        deleteAuthenticator: builder.mutation({
            query: () => ({
                url: `account/settings/authenticator/delete`,
                method: "DELETE",
            }),
            invalidatesTags: ["AuthQrCode"],
        }),
        updatePhoneNumber: builder.mutation({
            query: (body) => ({
                url: `account/settings/phone/edit`,
                method: "POST",
                body: body,
            }),
            keepUnusedDataFor: 0.0001,
        }),
        confirmPhoneNumberCode: builder.mutation({
            query: (body) => ({
                url: `account/settings/phone/confirm`,
                method: "POST",
                body: body,
            }),
            keepUnusedDataFor: 0.0001,
        }),
        deletePhoneNumber: builder.mutation({
            query: (body) => ({
                url: `account/settings/phone/delete`,
                method: "DELETE",
                body: body,
            }),
            invalidatesTags: ["PhoneNumber"],
        }),
        updateEmail: builder.mutation({
            query: (body) => ({
                url: `account/settings/email/edit`,
                method: "POST",
                body: body,
            }),
            keepUnusedDataFor: 0.0001,
        }),
        confirmEmailCode: builder.mutation({
            query: (body) => ({
                url: `account/settings/email/confirm`,
                method: "POST",
                body: body,
            }),
            keepUnusedDataFor: 0.0001,
        }),
        mFConfirm: builder.query({
            query: ({code, type, mfa_token}) => ({
                url: `mfa-confirm?code=${code}&mfa_token=${mfa_token}&type=${type}`,
                method: "POST",
            }),
            invalidatesTags: ["MFConfirm"],
        }),
    }),
    overrideExisting: false,
});

export const {
    useLazyGetSettingsPageQuery,
    useLazyGetAccountSettingsQuery,
    useAllowToMFAMutation,
    useLazyGetAuthenticatorQrQuery,
    useConfirmAuthQrCodeMutation,
    useDeleteAuthenticatorMutation,
    useUpdateEmailMutation,
    useUpdatePhoneNumberMutation,
    useConfirmPhoneNumberCodeMutation,
    useConfirmEmailCodeMutation,
    useLazyMFConfirmQuery,
} = settingsPageApi;
